import { Grid, Typography } from '@mui/material';
import type { Currency, PromotionInput } from '@weft/types';
import { PROMOTION_TYPES } from '@weft/types';
import { raise, raiseUnreachable, withDefault } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import React from 'react';
import { Price } from '../../../../../../components/design/Price';

type PromotionItemProps = {
  promotion: PromotionInput;
  currency: Currency;
};

export const PromotionItem: React.FC<PromotionItemProps> = ({ promotion, currency }) => {
  return (
    <Grid
      component="li"
      container
    >
      <Grid
        item
        xs={6}
      >
        <Typography
          color="#111B1E"
          fontWeight={400}
          fontSize="12px"
          lineHeight="16px"
        >
          {withDefault(promotion.name, '')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        textAlign="right"
      >
        <Typography
          color="#9DA8AC"
          fontWeight={300}
          fontSize="12px"
          lineHeight="16px"
        >
          Discount
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
      >
        <Typography
          color="#94A0A4"
          fontWeight={300}
          fontSize="10px"
          lineHeight="12px"
        >
          {withDefault(promotion.description, 'No Description')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        textAlign="right"
      >
        <Typography
          color="#111B1E"
          fontWeight={400}
          fontSize="12px"
          lineHeight="16px"
        >
          {getPromotionPrice(promotion, currency)}
        </Typography>
      </Grid>
    </Grid>
  );
};

function getPromotionPrice(promotion: PromotionInput, currency: Currency): React.ReactNode {
  switch (promotion.promotionModel.promotionType) {
    case PROMOTION_TYPES.Credit:
      return (
        <Price
          currency={currency}
          color="#111B1E"
          fontWeight={400}
          fontSize="12px"
          lineHeight="16px"
          align="right"
        >
          {-withDefault(promotion.promotionModel.promotionConfiguration.creditAmount, 0)}
        </Price>
      );
    case PROMOTION_TYPES.Percentage:
      return formatNumber(-withDefault(promotion.promotionModel.promotionConfiguration.percentage, 0), 2) + '%';
    case PROMOTION_TYPES.FreeTrial:
      return raise('Not implemented');
    default:
      return raiseUnreachable(promotion.promotionModel);
  }
}